export const departments = [
    {label: "All Departments"},
    {label: "HR/Recruitment"},
    {label: "IT"},
    {label: "Marketing/Sales"},
    {label: "Operations"},
    {label: "Other"}
]

